"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIconLarge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const LoadingIconLarge = () => {
    const [show, setShow] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => { setShow(true); }, 500);
        return () => {
            clearTimeout(timer);
        };
    }, []);
    if (!show)
        return null;
    return ((0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", style: { margin: "auto" }, width: "201", height: "201", display: "block", preserveAspectRatio: "xMidYMid", viewBox: "0 0 100 100", children: (0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("animateTransform", { attributeName: "transform", dur: "0.7633587786259541s", keyTimes: "0;1", repeatCount: "indefinite", type: "rotate", values: "0 50 50;360 50 50" }), (0, jsx_runtime_1.jsx)("circle", { cx: "50", cy: "50", r: "15", fill: "none", stroke: "#d2d2d2", strokeDasharray: "47.12388980384689 94.24777960769379", strokeLinecap: "round", strokeWidth: "5", children: (0, jsx_runtime_1.jsx)("animate", { attributeName: "stroke", dur: "0.7633587786259541s", keyTimes: "0;1", repeatCount: "indefinite", values: "#d2d2d2;#d2d2d2" }) })] }) }));
};
exports.LoadingIconLarge = LoadingIconLarge;
